"use client";
import React, { useEffect } from "react";
import { Formik } from "formik";
import { SignInSchema } from "../utils/formik-schema/signinSchema";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Input from "./Input";
import { useDispatch, useSelector } from "react-redux";
import { selectError, selectLoading, signIn } from "../redux/auth/authSlice";

function SignInForm() {
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const dispatch = useDispatch();

  const handleSignIn = async (values) => {
    dispatch(signIn(values));
  };

  useEffect(() => {
    if (error) {
      toast.error(error.data.msg);
    }
  }, [error]);

  const initialValues = {
    email: "",
    password: "",
  };

  return (
    <div className="flex justify-center w-full h-[90%] items-center text-black">
      <div className="sm:w-[50%] w-full flex flex-col justify-center items-center bg-white shadow-lg rounded-lg p-10 border-t-4 border-blue-500">
        <p className="my-3 text-4xl font-bold tracking-wide text-gray-800">
          Admin Login
        </p>

        <Formik
          initialValues={initialValues}
          validationSchema={SignInSchema}
          onSubmit={handleSignIn}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <form
              className="sm:w-[60%] w-full sm:p-0 p-10 flex flex-col justify-center space-y-4"
              onSubmit={handleSubmit}>
              <Input
                name="email"
                type="email"
                placeholder="Enter your email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.email}
                touched={touched.email}
                className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
              />
              <Input
                name="password"
                type="password"
                placeholder="Enter your password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.password}
                touched={touched.password}
                className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
              />

              <button
                className={`px-6 py-3 mt-4 text-lg font-medium text-white rounded-lg 
                ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-500 hover:bg-blue-600"
                } 
                transition duration-300 ease-in-out shadow-md`}
                type="submit"
                disabled={loading}>
                {loading ? "Signing In..." : "Sign In"}
              </button>

              <p className="mt-4 text-center text-gray-600">
                Are you an employee?{" "}
                <Link to="/users/sign-in">
                  <span className="font-semibold text-blue-500 hover:text-blue-700">
                    Login
                  </span>
                </Link>
              </p>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default SignInForm;
